import { render } from "./[-dealId].vue?vue&type=template&id=47a1d383&scoped=true"
import script from "./[-dealId].vue?vue&type=script&lang=js"
export * from "./[-dealId].vue?vue&type=script&lang=js"

import "./[-dealId].vue?vue&type=style&index=0&id=47a1d383&lang=scss&scoped=true"
import "./[-dealId].vue?vue&type=style&index=1&id=47a1d383&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47a1d383"]])

export default __exports__